<template>
    <div class="bg-white p-4 rounded-xl">
        <BRow class="justify-content-between">
            <BCol lg="4" v-if="filterDate">
                <!-- <slot name="filter"></slot> -->
                <!-- <div class="d-lg-flex d-flex align-items-center">
                    <div class="text-left mb-2 mb-lg-0">
                        <label for="" class="">Start Date</label>
                        <BFormInput type="date" class="" v-model="startDate"></BFormInput>
                    </div>
                    <div class="text-left mb-2 mb-lg-0">
                        <label for="" class="">End Date</label>
                        <BFormInput type="date" class="" v-model="endDate"></BFormInput>
                    </div>
                </div> -->
                <BRow class="mb-2 mb-lg-0">
                    <BCol class="text-left">
                        <label for="" class="">Start Date</label>
                        <BFormInput type="date" class="" v-model="startDate"></BFormInput>
    
                    </BCol>
                    <BCol class="text-left">
                        <label for="" class="">End Date</label>
                        <BFormInput type="date" class="" v-model="endDate"></BFormInput>
    
                    </BCol>
                </BRow>
            </BCol>
            <!-- <BCol md="6" class="d-flex justify-content-end">
                <slot name="filterandsearch"></slot>
                <slot name="cta"></slot>
            </BCol> -->
            <BCol :class="`d-lg-flex align-items-lg-center align-items-center mb-lg-0 ${cta ? 'mb-2' : 'mb-0'} ${cta || filterDate ? 'justify-content-end' : 'justify-content-end'} `">
                <BRow>
                    <BCol cols="3" :lg="cta ? '2' : '3'" :class="`${filterDate ? 'mb-2' : 'mb-0'} mb-lg-0 mr-lg-2`">
                        
                        <BButton v-if="filterModal" class="btn-filter d-lg-flex d-flex align-items-center align-items-lg-center mb-lg-0 " variant="light" @click="$emit('showFilter')">
                            <i class="fas fa-filter me-1"></i>
                            <span class="w-100">Filter</span>
                        </BButton>
                    </BCol>
                    <BCol cols="6" :lg="cta ? '6' : '9'" :class="`${cta ? 'mb-2' : 'mb-0' } mb-lg-0`">
                        <BInputGroup class="border rounded-lg">
                            <template #append>
                                <BButton variant="white"><i class="ios ion-ios-search text-black"></i></BButton>
                            </template>
                            
                            <BFormInput type="text" class="border-0" placeholder="Search">
                        
                            </BFormInput>
                        </BInputGroup>
                    </BCol>
                    <BCol v-if="cta">
                        <BButton class="btn-cta W-100" variant="primary" @click="$emit('action')"><i class="fas fa-plus"></i> {{ ctaText }}</BButton>
                    </BCol>
                </BRow>
            </BCol>
        </BRow>
    </div>
</template>

<script>
import {BRow, BCol, BButton, BFormInput, BInputGroup} from "bootstrap-vue-next";

export default {
    name: 'ActionContent',
    components: {
        BRow,
        BCol,
        BButton, BFormInput, BInputGroup
    },
    props: {
        ctaText: String,
        filterDate: {
            type: Boolean,
            default: true,
        },
        filterModal: {
            type: Boolean,
            default: true,
        },
        cta: {
            type: Boolean,
            default: true,
        },
    }
}
</script>

<style>
@media screen and (min-width: 768px) {
    .col-lg-4{
        min-width: 184px;
    }
}
</style>